<template>
  <el-dialog
    title
    :visible.sync="show"
    @close="onChange"
    :close-on-click-modal="false"
    width="500px"
    class="import-file-modall"
  >
    <div slot="title">{{ $t('stores::products-info::import_goods') }}</div>
    <div class="content-box" v-if="show">
      <el-upload
        :auto-upload="false"
        action=""
        ref="upload"
        drag
        class="btn-item"
        :http-request="customUpload"
        :on-change="onchangeUpload"
        :show-file-list="false"
      >
        <div class="upload-box" v-if="!select">
          <i class="iconfont iconUpload upload-btn mb-16"></i>
          <span>
            {{ $t('stores::products-info::import_tips') }}
            <a type="text">{{ $t('stores::products-info::import_btn') }}</a>
          </span>
        </div>
        <div class="upload-box" v-else>
          <span>{{ $t('stores::products-info::choose_file') }}</span>
          <span class="mt-10">{{ select.name }}</span>
        </div>
      </el-upload>
    </div>
    <div class="mt-10">
      <span>{{ $t('stores::products-info::import_example') }}</span>
      <a
        class="ml-5"
        :href="
          $store.state.language === 'en'
            ? '//ocean-img.algobuy.net/default/7d5bd82b847e419cb66f00108c10ca94.xlsx'
            : '//ocean-img.algobuy.net/common/aa92ab6fd013475587b9e35b14aca544.xlsx'
        "
        download="template.xlsx"
      >
        {{ $t('stores::products-info::import_example_btn') }}
      </a>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="onChange">{{ $t('system::common::btn::cancel') }}</el-button>
      <el-button type="primary" @click="onSub" :loading="loading">{{ $t('system::common::btn::confirm') }}</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { productsUpload } from '@/server/product'
export default {
  name: 'modal-back-email',
  components: {},
  model: {
    prop: 'visible',
    event: 'change'
  },
  props: {
    visible: {
      default: false
    },
    drawRow: {
      default: () => {}
    }
  },
  watch: {
    visible(bool) {
      this.show = bool
      this.fdata = null
      this.select = null
    },
    drawRow: {
      handler: function(data) {},
      deep: true
    }
  },
  data() {
    return {
      show: false,
      loading: false,
      fdata: null,
      select: null
    }
  },
  mounted() {},
  methods: {
    async getList() {
      this.loading = true
      const { data } = await getImportLogList({
        ...this.params,
        ...this.pagination
      })
      this.loading = false
      if (data.code === this.$code) {
        this.tableData = data.data.list
        this.pagination.total = data.data.total
      }
    },
    async customUpload(file) {
      this.fdata = new FormData()
      this.fdata.append('upload_file', file.file)
      this.loading = true
      const res = await productsUpload(this.fdata)
      if (res.data.code === this.$code) {
        this.$message.success(this.$t('system::tip::control_success'))
        this.$emit('save', false)
        this.$emit('change', false)
      }
      this.loading = false
    },
    onchangeUpload(file) {
      this.select = file
    },
    onChange() {
      this.$emit('change', false)
    },
    onTpl() {
      window.open('https://ocean-img.algobuy.net/common/aa92ab6fd013475587b9e35b14aca544.xlsx')
    },
    async onSub() {
      // this.loading = true;
      if (!this.select) {
        this.$message.warning(this.$t('stores::products-info::message_choose_file'))
        return false
      }
      this.$refs.upload.submit()
      // // const res = await productsUpload(this.fdata)
      // if (res.code === this.$code) {
      //   this.$message.success(this.$t('system::tip::control_success'))
      //   this.$emit('save', false)
      // }
      // this.loading = false
    }
  }
}
</script>
<style lang="scss" scoped>
.import-file-modall {
  .content-box {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  ::v-deep {
    .el-upload-dragger {
      display: flex;
      align-items: center;
    }
  }
  .upload-box {
    margin: 0 auto;
    flex-direction: column;
    flex-wrap: wrap;
    display: flex;
    align-items: center;
    justify-content: center;
    .upload-btn {
      font-size: 40px;
    }
  }
}
</style>
